import { fieldStyle, labelStyle, inputStyle } from '../../constants/general';

export const StylesPreferences = ({ formik }) => {
  return (
    <>
      <div className={fieldStyle}>
        <label htmlFor="formColor" className={labelStyle}>
          Form Background Color
        </label>

        <input
          id="formColor"
          type="color"
          className={inputStyle}
          value={formik.values.formColor}
          onChange={formik.handleChange}
        />
      </div>

      <div className={fieldStyle}>
        <label htmlFor="formFont" className={labelStyle}>
          Form Font
        </label>

        <select
          id="formFont"
          className={inputStyle}
          value={formik.values.formFont}
          onChange={formik.handleChange}
        >
          <option value="Arial">Arial</option>
          <option value="Courier New">Courier New</option>
          <option value="Helvetica">Helvetica</option>
          <option value="Open Sans">Open Sans</option>
          <option value="Times New Roman">Times New Roman</option>
          <option value="Verdana">Verdana</option>
        </select>
        {formik.touched.formFont && formik.errors.formFont ? (
          <div className="text-error text-sm mt-1">{formik.errors.formFont}</div>
        ) : null}
      </div>

      {/* TODO: add form logo */}
    </>
  );
};
